import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { DataTablePagination, MotivoTransferenciaReserva as MotivoTransferencia } from '@/types/_'
import { Hospital as HospitalImp, MotivoTransferenciaReserva } from '@/types/core'

enum StatusEnum
{
  Ativo,
  Removido
}

@Module({ namespaced: true, name: 'SuporteMotivoTransferenciaReservaStore' })
export default class SuporteMotivoTransferenciaReservaStore extends VuexModule {
  hospitalImp = new HospitalImp.Hospital()
  motivoTransferenciaReservaImp = new MotivoTransferenciaReserva.MotivoTransferenciaReserva()

  private paginationDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [10, 50, 100, 200],
  }

  private motivoTransferenciaReservaDefault: MotivoTransferencia = {
    descricao: '',
    id: '',
    hisId: '',
    medicoVisualiza: false,
    status: '',
  }

  public acao: string = 'Cadastar'
  public motivoTransferenciaReserva: MotivoTransferencia = { ...this.motivoTransferenciaReservaDefault }
  public pagination: DataTablePagination = { ...this.paginationDefault }
  public motivosTransferenciaReserva: MotivoTransferencia[] = []
  public hospitalId: string = ''
  public conviteSearch: string = ''

  @Mutation
  setConviteSearch(value: string) {
    this.conviteSearch = value
  }

  @Mutation
  setAcao(acao: string) {
    this.acao = acao
  }

  @Mutation
  setHospitalId(id: any) {
    this.hospitalId = id
  }

  @Mutation
  setMotivosTransferenciaReserva(itens: MotivoTransferencia[]) {
    this.motivosTransferenciaReserva = itens
  }

  @Mutation
  setMotivoTransferenciaReserva(item: MotivoTransferencia) {
    this.motivoTransferenciaReserva = item
  }

  @Mutation
  clearMotivoTransferenciaReserva() {
    this.motivoTransferenciaReserva = { ...this.motivoTransferenciaReservaDefault }
  }

  @Action
  async getMotivosTransferenciaReservaByHospital() {
    const response = await this.motivoTransferenciaReservaImp.getMotivosTransferenciaReservaByHospital({ hospitalId: this.hospitalId })
    if (response.success) {
      const { commit } = this.context
      commit('setMotivosTransferenciaReserva', response.data as MotivoTransferencia[] || [])
    }
    return response
  }

  @Action
  async send() {
    const response = this.motivoTransferenciaReserva.id
      ? await this.motivoTransferenciaReservaImp.atualizar({ hospitalId: this.hospitalId, ...this.motivoTransferenciaReserva })
      : await this.motivoTransferenciaReservaImp.cadastrar({
        hospitalId: this.hospitalId,
        status: StatusEnum.Ativo,
        medicoVisualiza: this.motivoTransferenciaReserva.medicoVisualiza,
        hisId: this.motivoTransferenciaReserva.hisId,
        descricao: this.motivoTransferenciaReserva.descricao,
      })

    return response
  }
}
